var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkSharpColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41666 25.3743V7.24935H9.66666V2.41602H19.3333V7.24935H26.5833V25.3743H2.41666ZM12.0833 7.24935H16.9167V4.83268H12.0833V7.24935Z",
    fill: "#84E1CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkSharpColor);
export default __webpack_public_path__ + "static/media/work-sharp-color.7127d8775c16e292f92ec74d42e323fb.svg";
export { ForwardRef as ReactComponent };